export default __webpack_public_path__ + "static/media/discover-card-selected.b6c3d301.svg";